<template>
  <u-dashboard-toolbar />
  <u-dashboard-panel-content>
    <content-doc :head="false" />
  </u-dashboard-panel-content>
</template>

<script lang="ts" setup>
useHead({
  title: 'The Show Portal - Privacy Policy',
})

const app = useApp()

app.data.title = 'Privacy Policy'
</script>

<style lang="scss" scoped>
:deep(p) {
  margin: 1rem 0;
}
</style>
